<template>
  <div id="app">
    <!-- 登录页面只显示router-view -->
    <div v-if="$route.path === '/login'" style="height: 100%">
      <router-view></router-view>
    </div>

    <!-- 其他页面显示完整布局 -->
    <el-container v-else style="height: 100vh; border: 1px solid #eee">
      <el-header
        style="
          background-color: #fff;
          border-bottom: 1px solid #eee;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div style="display: flex; align-items: center">
          <el-button
            icon="el-icon-menu"
            @click="isCollapsed = !isCollapsed"
            style="margin-right: 15px"
            type="text"
          ></el-button>
          <div style="font-size: 20px; font-weight: bold; color: #409eff">
            蒙旅国际旅行社客资管理系统
          </div>
        </div>
        <el-dropdown>
          <span class="el-dropdown-link">
            {{ username }} <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>个人中心</el-dropdown-item>
            <el-dropdown-item @click.native="handleLogout"
              >退出登录</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </el-header>
      <el-container>
        <el-aside
          :width="isCollapsed ? '64px' : '200px'"
          style="background-color: #f5f7fa; border-right: 1px solid #eee"
        >
          <el-menu
            :default-active="activeIndex"
            class="el-menu-vertical-demo"
            @select="handleSelect"
            :collapse="isCollapsed"
            :collapse-transition="false"
          >
            <el-menu-item index="/dashboard">
              <i class="el-icon-s-home"></i>
              <span slot="title">首页</span>
            </el-menu-item>
            <el-menu-item index="/users" v-if="isAdmin">
              <i class="el-icon-user"></i>
              <span slot="title">员工管理</span>
            </el-menu-item>
            <el-menu-item index="/customers">
              <i class="el-icon-document"></i>
              <span slot="title">客资管理</span>
            </el-menu-item>
            <el-menu-item index="/customer-pool">
              <i class="el-icon-collection"></i>
              <span slot="title">客户池</span>
            </el-menu-item>
            <el-menu-item index="/invalid-customer-pool">
              <i class="el-icon-collection-tag"></i>
              <span slot="title">无效客户池</span>
            </el-menu-item>
            <el-menu-item index="/my-customers">
              <i class="el-icon-document-copy"></i>
              <span slot="title">我的客户</span>
            </el-menu-item>
            <el-menu-item index="/transaction-management">
              <i class="el-icon-money"></i>
              <span slot="title">成交管理</span>
            </el-menu-item>
            <el-submenu index="file-pool">
              <template slot="title">
                <i class="el-icon-folder"></i>
                <span>文件池</span>
              </template>
              <el-menu-item index="/admin-file-pool" v-if="isAdmin"
                >管理员文件池</el-menu-item
              >
              <el-menu-item index="/my-file-pool">我的文件池</el-menu-item>
            </el-submenu>
            <el-submenu index="system">
              <template slot="title">
                <i class="el-icon-setting"></i>
                <span>系统管理</span>
              </template>
              <el-menu-item index="/settings">系统设置</el-menu-item>
              <el-menu-item index="/log-query">日志查询</el-menu-item>
              <el-menu-item index="/suppliers">供应商管理</el-menu-item>
            </el-submenu>
          </el-menu>
        </el-aside>
        <el-main style="padding: 20px">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      activeIndex: '/dashboard',
      username: this.getUsername(),
      isAdmin: false, // 是否是超级管理员
      isCollapsed: false // 菜单折叠状态
    }
  },
  mounted () {
    // 监听路由变化，更新激活的菜单项
    this.$watch('$route.path', (newPath) => {
      this.activeIndex = newPath
    })
    // 检查当前用户是否是超级管理员
    this.checkIfAdmin()
  },
  methods: {
    // 获取当前登录用户的姓名
    getUsername () {
      const employeeStr = localStorage.getItem('employee')
      if (employeeStr) {
        try {
          const employee = JSON.parse(employeeStr)
          return employee.name || employee.username || '管理员'
        } catch (e) {
          console.error('解析员工信息失败:', e)
        }
      }
      return localStorage.getItem('username') || '管理员'
    },
    // 检查当前用户是否是超级管理员
    checkIfAdmin () {
      const employeeStr = localStorage.getItem('employee')
      if (employeeStr) {
        try {
          const employee = JSON.parse(employeeStr)
          this.isAdmin = employee.role === 'admin'
        } catch (e) {
          console.error('解析员工信息失败:', e)
          this.isAdmin = false
        }
      } else {
        this.isAdmin = false
      }
    },
    handleSelect (key) {
      // 避免重复导航到当前路由
      if (this.$route.path !== key) {
        this.$router.push(key)
      }
    },
    handleLogout () {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 清除localStorage中的token和用户名
        localStorage.removeItem('token')
        localStorage.removeItem('username')
        localStorage.removeItem('rememberMe')

        // 跳转到登录页面
        this.$router.push('/login')
        this.$message.success('退出登录成功')
      }).catch(() => {
        this.$message.info('已取消退出登录')
      })
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#app {
  height: 100%;
}

.el-header {
  padding: 0 20px;
}

.el-aside {
  padding: 20px 0;
  transition: width 0.3s ease;
}

.el-menu {
  border-right: none;
  height: 100%;
  overflow: hidden;
}
</style>
